import type * as React from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';
import * as style from './style.css';

export const BuilderOffersNotAvailableMobile = (): React.JSX.Element => {
  return (
    <div className={style['container']} data-testid="BuilderOffersNotAvailable">
      <div className={style['image']}>
        <div className={style['logo']} />
      </div>
      <div className={style['description']}>
        <UIHeading3 textAlign="center">В этом ЖК подходящих предложений от&nbsp;застройщика нет</UIHeading3>
        <UIText2 textAlign="center">Узнайте об остатках у застройщика</UIText2>
      </div>
    </div>
  );
};
